/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 * Container for all filters
 */
import React, { Component } from 'react';
import { FlatButton } from 'material-ui';

class Container extends Component {
    render() {
        const { children, contents, onSearch, onClear } = this.props;
        return (
            <div className="container-fluid">
                <div className="row">
                    <div
                        id="filter-sidebar"
                        className="col-lg-2 col-md-2 col-sm-3 hidden-sm-down sidebar-nav-fixed affix pl0 sliding-sidebar" >
                        <div className="background-white box-shadow padding-2 responsive-filters" >

                            <div className="navbar visible-xs" >
                                <button
                                    className="btn btn-default navbar-btn btn-filtros"
                                    data-toggle="collapse" data-target="#filter-sidebar">
                                    <i className="fa fa-tasks" /> Cerrar
                                </button>
                            </div>
                            <h4>Filtros</h4>
                            <div className="panel-group" id="accordion">
                                {children}
                                <div className="pt2 filters-panel hidden-sm-down" >
                                    <FlatButton fullWidth label="Limpiar Filtros" onTouchTap={() => onClear()} />
                                    <FlatButton
                                        className="filters-buscar"
                                        fullWidth
                                        label="Buscar"
                                        primary
                                        onTouchTap={() => onSearch()}
                                    />
                                </div>
                                <div className="pt2 filters-panel visible-xs" style={{ marginBottom: '5rem'}}>
                                    <FlatButton fullWidth label="Limpiar Filtros" onTouchTap={() => onClear()} />
                                    <FlatButton
                                        className="filters-buscar"
                                        fullWidth
                                        label="Buscar"
                                        primary
                                        onTouchTap={() => onSearch()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-9 ml-sm-auto">
                        {contents}
                    </div>
                </div>
            </div>
        );
    };
}

export default Container;



// WEBPACK FOOTER //
// ./components/filters/container.js